import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { IState } from '../store';

export const isSuburbanOfferFromBuilder = ({ isResale, offerType }: IOfferSchema) =>
  offerType === 'suburban' && isResale !== null && !isResale;

export const showCountrysideBuilderBadge = ({ isCountrysideOffersBuilderBadgeEnabled, offerData }: IState): boolean =>
  isCountrysideOffersBuilderBadgeEnabled && isSuburbanOfferFromBuilder(offerData.offer);
